import { Alert, Box, Link, Typography } from '@mui/material'
import React from 'react'

const PermissionsWarning = () => {
  return (
    <Box sx={{ py: 4, textAlign: 'center' }}>
      <Box
        display="flex"
        minHeight="40vh"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
        }}
      >
        <Alert severity="error">
          <Typography variant="h6" sx={{ marginBottom: '1rem' }}>
            You don't have permissions to view perks at this time.
          </Typography>
          <Typography variant="body1">
            Please contact support via help@techstars.com if you believe you
            should have access.
          </Typography>
          <Typography variant="body1">
            If you are trying to submit a perk, please visit{' '}
            <Link
              href="https://perks.techstars.com/perks/s/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://perks.techstars.com/perks/s/
            </Link>
            .
          </Typography>
        </Alert>
      </Box>
    </Box>
  )
}

export default PermissionsWarning
